import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'qtr-month',
    template: `
        <select name="county" (change)="onQrtChange($event.target.value)" required>
          <option value="0">Select Qtr/Year</option>
          <option value="{{p}}" *ngFor="let p of monthYear" [selected]="currMonthYear == p">{{p}}</option>
        </select>`
})

export class QtrMonthComponent implements OnInit {

    months: any = [];
    monthE: any = [];
    years: any = [];
    yy: number;
    mm: number;
    cMonth: string;
    monthYear: any = [];
    currMonthYear: string;
    beginnerQtrM: string;
    public beginnerQtr: string;
    endQtr: string;
    reportDate: any = {};
    monthYearshow: any = {};
    theYear: string;
    theMonth: string;


    ngOnInit() {
        this.months = [
            { val: '10', name: '01' },
            { val: '01', name: '02' },
            { val: '04', name: '03' },
            { val: '07', name: '04' }
        ];
        this.monthE = ["31", "28", "31", "30", "31", "30", "31", "31", "30", "31", "30", "31"];
        var today = new Date();
        var endQtrM;
        var ecy: number;
        this.yy = today.getFullYear();
        this.mm = today.getMonth() + 1;
        for (var y = 0; y < this.months.length; y++) {
            if (this.months[y].val <= this.mm) {
                /* if (y != 0) { */
                this.beginnerQtrM = this.months[y].val;
                this.cMonth = this.months[y].name;
                endQtrM = parseInt(this.months[y].val) + 2;
                ecy = this.yy;


            }
        }
        if (this.cMonth == '01') {
            var yy = this.yy - 1;
            var ecy = ecy - 1;
            this.currMonthYear = this.cMonth + ' / ' + yy;
            this.beginnerQtr = this.beginnerQtrM + '/01/' + ecy;
        } else {
            this.currMonthYear = this.cMonth + ' / ' + this.yy;
            this.beginnerQtr = this.beginnerQtrM + '/01/' + ecy;
        }
        this.endQtr = endQtrM + '/' + this.monthE[endQtrM - 1] + '/' + this.yy;
        for (var i = (this.yy - 8); i <= this.yy; i++) {
            this.years.push(i);
        }
        for (var j = 0; j < this.years.length; j++) {
            for (let k = 0; k < this.months.length; k++) {
                this.monthYear.push(this.months[k].name + ' / ' + this.years[j]);
            }
        }
    }
    onQrtChange(e) {
        const x = e.split(" / ");
        const cm = x[0];
        const cy = x[1];
        let ecy = x[1];
        let endQtrM;
        this.cMonth = cm;
        this.yy = cy;
        for (let y = 0; y < this.months.length; y++) {
            if (this.months[y].name === cm) {
                this.mm = this.months[y].val;
            }
            if (this.months[y].val <= this.mm && this.months[y].val >= this.mm) {

                /* if (y !== 0) { */
                this.beginnerQtrM = this.months[y].val;
                endQtrM = parseInt(this.months[y].val) + 2;
                ecy = cy;
                /* } else {
                     this.beginnerQtrM = '10';
                     endQtrM = this.months[y].val;
                     ecy = parseInt(cy) - 1;
                 } */

            }
        }
        if (this.beginnerQtrM == '10') {
            var yy = ecy - 1;
            var cyy = cy - 1;
            this.beginnerQtr = this.beginnerQtrM + '/01/' + yy;
            this.endQtr = endQtrM + '/' + this.monthE[endQtrM - 1] + '/' + cyy;
        } else {
            this.beginnerQtr = this.beginnerQtrM + '/01/' + ecy;
            this.endQtr = endQtrM + '/' + this.monthE[endQtrM - 1] + '/' + cy;
        }
    }

    getDates() {
        this.ngOnInit();
        this.reportDate.beginnerQtr = this.beginnerQtr;
        this.reportDate.endQtr = this.endQtr;
        return this.reportDate;
    }

    getDatesChange(e) {
        this.onQrtChange(e);
        this.reportDate.beginnerQtr = this.beginnerQtr;
        this.reportDate.endQtr = this.endQtr;
        return this.reportDate;
    }

    getMonthYearChange(e) {
        this.onQrtChange(e);
        this.monthYearshow.month = this.cMonth;
        this.monthYearshow.year = this.yy;
        return this.monthYearshow;
    }

    getMonthYear() {
        this.ngOnInit();
        this.monthYearshow.month = this.cMonth;
        this.monthYearshow.year = this.yy;
        return this.monthYearshow;
    }

}



// WEBPACK FOOTER //
// ./src/app/monthpicker/QtrMonth.ts